import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

const subjects = Object.freeze([
  {
    id: 'S',
    value: 'iscritto AIRE',
  },
  {
    id: 'N',
    value: 'residente in Italia',
  },
]);

interface AireParams {
  disabled?: boolean;
  required?: boolean;
  value?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const AireListComponent = ({
  disabled,
  onChange,
  required,
  value = 'N',
  error,
  label = 'Aire',
  id = 'aire',
}: AireParams): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="aire-label" disabled={disabled}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId="aire-label"
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {subjects.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

AireListComponent.displayName = 'Aire list component';

const AireList = memo(AireListComponent);

export default AireList as typeof AireListComponent;
